<template>
  <el-dialog :visible.sync="dialogVisible" custom-class="custom-dialog" append-to-body :close-on-click-modal="false" top="10vh" class="allot-belonger" width="800px">
    <div slot="title" class="title">
      <div class="title-name">请选择归属顾问</div>
      <div class="side-title"></div>
      <div class="handle-btn"></div>
      <div class="dialog-close-btn" @click="dialogVisible = false">X</div>
    </div>
    <div>
      <div class="content-row align-center">
        <span class="text-no-wrap" style="width:108px;flex:none;">顾问名称：</span>
        <el-select v-model="account" filterable style="width:33%" size="mini" placeholder="请选择顾问名称">
          <el-option v-for="item in accounts" :key="item" :label="item" :value="item"></el-option>
        </el-select>
      </div>

    </div>

    <span slot="footer" class="footer-box">
      <el-button size="mini" class="mr10" type="primary" @click="confirm">加入待沟通</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    project: { type: Object,default: ()=>{} },
  },
  data() {
    return {
      dialogVisible: false,
      account: '',
      accounts: [],
    }
  },
  methods: {
    open(account) {
      this.account = account || ''
      this.dialogVisible = true
      this.setOptions()
    },
    setOptions(){
      const fields = ['客户开发','项目对接','项目经理','项目成员']
      const arr = []
      fields.forEach(field=>{
        arr.push(...(this.project[field]||[]))
      })
      this.accounts = [...new Set(arr)].filter(v=>v)
      this.accounts.push('')
      console.log(this.accounts);
    },
    confirm() {
      if(!this.account) return this.$message.error('请选择顾问')
      this.$emit('confirm',this.account)
      this.dialogVisible = false
    },
  },
}
</script>
<style>
.allot-belonger .el-dialog__body {
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>
<style scoped src="../../../company/statistics/css/commonCompany.css"></style>
